module.exports = __webpack_public_path__ + "static/media/icon_plus_2.2c0f52e8.svg";